import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: '黑料社区官网是什么？',
    answer: '黑料社区官网是一个专注于真实内容分享与社区讨论的在线平台。我们汇聚了社会热点、娱乐八卦、行业揭秘、深度调查等多种类型的内容，致力于为用户提供一个开放、透明、安全的信息交流环境。用户可以在平台上浏览各类独家爆料内容，参与话题讨论，也可以提交自己的真实见闻与社区成员分享。',
  },
  {
    question: '如何访问黑料社区官网入口？',
    answer: '您可以通过官方域名 heiliaoshequ.com 直接访问黑料社区官网。建议将官网地址添加到浏览器收藏夹中，以便随时访问。如果遇到无法访问的情况，请检查您的网络连接是否正常，或尝试清除浏览器缓存后重新访问。我们也会通过官方社交媒体渠道发布最新的访问地址信息。',
  },
  {
    question: '黑料社区的内容是否真实可靠？',
    answer: '我们高度重视内容的真实性和可靠性。所有投稿内容在发布前都会经过编辑团队的多轮审核与核实。对于涉及重大事件的内容，我们会尽可能联系多方信源进行交叉验证。同时，我们也鼓励社区用户对内容的真实性进行监督，如发现不实信息，可以通过举报功能及时反馈。但需要说明的是，部分用户投稿内容可能含有主观判断，请读者结合多方信息独立判断。',
  },
  {
    question: '如何在黑料社区投稿发布内容？',
    answer: '目前，您可以通过"网友投稿"功能提交您的内容。在社区首页点击"我要爆料"按钮，按照指引填写标题、正文和相关素材即可。我们的编辑团队会在收到投稿后的24小时内完成审核，审核通过后内容将展示在对应的分类板块中。请确保您提交的内容真实、原创，且不侵犯他人合法权益。',
  },
  {
    question: '黑料社区是否需要付费使用？',
    answer: '黑料社区目前所有内容均免费向用户开放，您无需支付任何费用即可浏览全站内容、参与社区讨论。我们致力于为用户提供优质的免费内容服务。未来如果推出付费增值服务，我们将会提前在官网进行公告，并确保现有免费服务的正常使用不受影响。',
  },
  {
    question: '如何确保在黑料社区的安全与隐私？',
    answer: '黑料社区非常重视用户的隐私安全。我们采用了先进的数据加密技术来保护用户信息，所有用户数据均按照相关法律法规进行管理和存储。投稿用户可以选择匿名发布，您的个人信息不会被公开显示。我们建议您不要在公开内容中透露个人敏感信息，如遇到隐私泄露等问题，请及时联系客服处理。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <section id="faq" className="py-14 md:py-20 bg-background-100">
        <div className="container-custom">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              常见问题
            </h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">
              关于黑料社区的常见疑问，这里都有解答
            </p>
          </div>

          <div className="max-w-3xl mx-auto flex flex-col gap-3">
            {faqItems.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden"
              >
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                >
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                    {item.question}
                  </h3>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}>
                    <i className="ri-arrow-down-s-line text-foreground-500"></i>
                  </div>
                </button>
                {openIndex === index && (
                  <div className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                    {item.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}